const Employers = () => import('@/views/Application/Employers/Employers');
const FormEmployer = () => import('@/views/Application/Employers/FormEmployer');

export default [
  {
    path: '/dashboard/employers',
    name: 'employers',
    component: Employers,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/employers/:id',
    name: 'add-update-employer',
    component: FormEmployer,
    meta: {
      requiresAuth: true,
    },
  },
];
